import { create } from 'zustand';
import { getErrorMessage } from '@/shared/lib/errors';
import { RequestStatus } from '@/shared/model/requestStatus';
import { problemExecutorService } from '../api/problemExecutorService';
import type { ProblemExecutorState } from './types';

/** Хранит страницу отзывов с низкими оценками */
export const useProblemExecutors = create<ProblemExecutorState>((set, get) => ({
    items: [],
    allCount: 0,
    status: RequestStatus.Idle,
    error: null,
    revision: 0,

    load: async (query) => {
        const revision = get().revision + 1;

        set({
            revision,
            items: [],
            allCount: 0,
            status: RequestStatus.Loading,
            error: null,
        });

        try {
            const response = await problemExecutorService.getList(query);

            if (get().revision !== revision) return;

            set({
                items: response.items ?? [],
                allCount: response.allCount ?? 0,
                status: RequestStatus.Success,
            });
        } catch (error: unknown) {
            if (get().revision !== revision) return;

            set({
                status: RequestStatus.Error,
                error: getErrorMessage(error, 'Не удалось загрузить проблемных исполнителей'),
            });
        }
    },

    reset: () => set({
        items: [],
        allCount: 0,
        status: RequestStatus.Idle,
        error: null,
        revision: get().revision + 1,
    }),
}));

